export enum RouterProviderEnum {
  SUNFLOWER = 'sunflower',
  PAY_COM = 'pay_com',
}
